<template>
  <v-container style="position: relative">
    <v-btn
      icon
      small
      @click="onClose"
      style="position: absolute; top: 10px; right: 10px"
    >
      <v-icon small>mdi-close</v-icon>
    </v-btn>
    <v-row>
      <v-col cols="6">
        <v-row align="end" class="fill-height">
          <v-col>
            <h3>{{ $t('select_business') }}</h3>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          small
          outlined
          :disabled="loadingProfile || profiles.length >= maxBusiness"
          @click="setCreateProfileData"
          style="border-radius: 38px 38px 0px 38px !important"
        >
          <v-icon left small>mdi-plus</v-icon>
          {{ $t('add_field') }}
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="loadingProfile">
      <v-col cols="4" v-for="n in 6" :key="n">
        <v-skeleton-loader type="card"></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row
      v-else-if="
        profiles.filter(
          (f) => !f.channel_profile_connect.find((c) => c.id === 7)
        ).length
      "
    >
      <v-col
        cols="4"
        v-for="(item, index) in profiles.filter(
          (f) => !f.channel_profile_connect.find((c) => c.id === 7)
        )"
        :key="index"
      >
        <v-card
          outlined
          :class="{ hover: item.channel_member_role.id === 1 }"
          :style="{
            filter: item.channel_member_role.id !== 1 ? 'brightness(0.9)' : '',
            height: '100%',
            position: 'relative',
            overflow: 'hidden'
          }"
          @click="
            item.channel_member_role.id === 1 && businessConnect(item, false)
          "
        >
          <VerifyBusinessAction
            v-if="
              (!item.channel_profile_connect ||
                !item.channel_profile_connect.find((c) => c.id === 7)) &&
              item.email_validation_status &&
              item.email_validation_status.status_description === 'PENDING'
            "
            :channelId="item.id"
            @accept="
              getProfilesData()
              getProfileSelectionData && getProfileSelectionData()
            "
            @decline="
              getProfilesData()
              getProfileSelectionData && getProfileSelectionData()
            "
          />
          <v-card-text class="text-center">
            <p class="text-truncate">{{ item.name }}</p>
          </v-card-text>
          <v-img
            v-if="item.picture_url"
            :src="item.picture_url"
            contain
            height="100"
            style="width: 100%"
          />
          <v-icon
            v-else
            color="grey lighten-1"
            size="75"
            style="width: 100%; padding-bottom: auto"
            >mdi-image</v-icon
          >
        </v-card>
      </v-col>
    </v-row>

    <div v-else class="text-center">
      <p>{{ $t('suggest_add_business') }}</p>
    </div>

    <v-row v-if="!isDisablePagination">
      <v-col class="d-flex justify-center mt-3">
        <v-pagination
          v-model="page"
          :length="paginationCount"
          color="primary"
          outlined
        />
      </v-col>
    </v-row>

    <v-dialog
      v-model="showDialogBusinessForm"
      max-width="800px"
      content-class="custom-dialog"
    >
      <v-card>
        <v-card-text>
          <ProfileTabs
            :pageProfile="page"
            :profileToEdit="profileToEdit"
            :editProfile="editProfile"
            :createProfile="createProfile"
            :setShowDialog="(val) => (showDialogBusinessForm = val)"
            :getProfilesData="getProfilesData"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {
  DEFAULT_PROFILE_SELECTION,
  PROFILE_PAGE_SIZE
} from '../../config/constant'
import ProfileTabs from './ProfileTabs.vue'
import VerifyBusinessAction from './VerifyBusinessAction.vue'

export default {
  name: 'Business',
  props: {
    maxBusiness: Number,
    profileSelection: Object,
    getProfileSelectionData: Function,
    onClose: Function,
    isCreateProfile: Boolean,
    isConnectApp: Object
  },
  components: {
    ProfileTabs,
    VerifyBusinessAction
  },
  mounted() {
    setTimeout(() => {
      this.showDialogBusinessForm = this.isCreateProfile
    }, 300)
  },
  data() {
    return {
      page: 1,
      paginationCount: 1,
      isDisablePagination: true,
      profiles: DEFAULT_PROFILE_SELECTION.channel_profile,
      profileToEdit: DEFAULT_PROFILE_SELECTION.channel_profile[0],
      loadingProfile: true,
      showDialogBusinessForm: false
    }
  },
  watch: {
    isConnectApp: {
      immediate: true,
      handler(val) {
        if (val) {
          this.businessConnect(val.channel_profile, true)
        }
      }
    }
  },
  created() {
    this.getProfilesData()
  },
  methods: {
    async editProfile(profile) {
      this.$store.dispatch('setOverlay', true)
      try {
        const res = await this.$store.dispatch(
          'ssoAccount/patchProfile',
          profile
        )
        if (res && res.status === 200) {
          this.$fire({
            title: this.$t('success'),
            type: 'success',
            reverseButtons: true,
            showCancelButton: false
          }).then(() => {
            this.getProfilesData()
            this.getProfileSelectionData()
            this.showDialogBusinessForm = false
          })
        }
      } catch (err) {
        this.$fire({
          title: this.$t(err.response.data?.message),
          type: 'error',
          reverseButtons: true,
          showCancelButton: false
        })
      } finally {
        this.$store.dispatch('setOverlay', false)
      }
    },

    async createProfile(profile) {
      this.$store.dispatch('setOverlay', true)
      try {
        const res = await this.$store.dispatch(
          'ssoAccount/postProfile',
          profile
        )
        if (res && res.status === 200) {
          this.$fire({
            title: this.$t('success'),
            type: 'success',
            reverseButtons: true,
            showCancelButton: false
          }).then(async () => {
            this.getProfilesData()
            this.getProfileSelectionData()
            this.showDialogBusinessForm = false
            await this.businessConnect(res.data.result, true)
          })
        }
      } catch (err) {
        this.$fire({
          title: this.$t(err.response.data?.message),
          type: 'error',
          reverseButtons: true,
          showCancelButton: false
        })
      } finally {
        this.$store.dispatch('setOverlay', false)
      }
    },

    async businessConnect(business, silent) {
      this.$store.dispatch('setOverlay', true)
      this.loadingProfile = true
      try {
        await this.$store.dispatch('ssoAccount/postAccountConnectApp', {
          businessId: business.id,
          appId: 7
        })

        if (!silent) {
          this.$fire({
            title: this.$t('success'),
            type: 'success',
            reverseButtons: true,
            showCancelButton: false
          }).then(async () => {
            this.onClose()
            this.getProfileSelectionData()
            await this.navigateToChecklist(business)
          })
        } else {
          await this.navigateToChecklist(business)
          this.onClose()
          this.getProfileSelectionData()
        }
      } catch (err) {
        this.$fire({
          title: this.$t(err.response.data?.message),
          type: 'error',
          reverseButtons: true,
          showCancelButton: false
        })
      } finally {
        this.$store.dispatch('setOverlay', false)
        this.loadingProfile = false
      }
    },

    async navigateToChecklist(business) {
      sessionStorage.setItem('businessId', business.id)

      const [shopRes] = await Promise.all([
        this.$store.dispatch('login/getShopProfile', business.id),
        this.$store.dispatch('ssoAccount/getMemberRolePermission', business.id)
      ])
      if (shopRes) {
        const path = `/${this.currentLang}/home?business_id=${business.id}`
        window.location.href = path
      }
    },

    getProfilesData() {
      this.loadingProfile = true
      if (!this.isDisablePagination) {
        this.paginationCount = Math.ceil(
          this.profileSelection.total_channel_profile / PROFILE_PAGE_SIZE
        )
        this.profiles = this.profileSelection.channel_profile.slice(
          0,
          PROFILE_PAGE_SIZE
        )
      } else {
        this.profiles = this.profileSelection.channel_profile
      }
      this.loadingProfile = false
    },

    setCreateProfileData() {
      this.profileToEdit = DEFAULT_PROFILE_SELECTION.channel_profile[0]
      this.showDialogBusinessForm = true
    }
  }
}
</script>

<style scoped>
.hover {
  cursor: pointer;
  transition: 0.2s;
}
.hover:hover {
  background-color: #f5f5f5;
}
.custom-dialog {
  z-index: 203 !important; /* or any number you need */
}
</style>
